import { Typography } from "@mui/material";
import React, { useState } from "react";
import CommonButton from "../../../component/Button";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { platformBlackLogo } from "../../../utils/logo";

export default function ErrorFallback() {
  const [data, setData] = useState({
    disable: false,
    reLoading: false,
    backLoading: false,
  });
  const handleReload = () => {
    window.location.reload();
    setData((prev) => ({
      ...prev,
      disable: true,
      reLoading: true,
      backLoading: false,
    }));
  };

  const handleGoBack = () => {
    window.history.back();
    setTimeout(() => {
      window.location.reload();
    }, 100);
    setData((prev) => ({
      ...prev,
      disable: true,
      reLoading: false,
      backLoading: true,
    }));
  };

  console.log(data, "datadata");
  return (
    <CommonGrid2
      padding="0rem 1rem"
      display={"flex"}
      justifyContent={"center"}
      flexDirection={"column"}
      height={"100vh"}
      alignItems={"center"}
    >
      {platformBlackLogo({width: "200px", height: "65px"})}
      <Typography variant="h3" marginTop={"2rem"} fontWeight={600}>
        We’re having trouble loading this page.
      </Typography>

      <CommonGrid2
        display={"flex"}
        gap={"1rem"}
        flexWrap={"wrap"}
        justifyContent={"center"}
        marginTop={"2rem"}
      >
        <CommonButton
          startIcon={data.backLoading ? "" : <ArrowBackIcon />}
          value={"Go Back"}
          onClick={handleGoBack}
          padding={"10px 1rem"}
          gap={data.backLoading ? "5px" : "0px"}
          fontWeight={600}
          disabled={data.disable}
          loading={data.backLoading}
        />

        <CommonButton
          value={"Reload Page"}
          onClick={handleReload}
          padding={"10px 1rem"}
          fontWeight={600}
          disabled={data.disable}
          loading={data.reLoading}
        />
      </CommonGrid2>
    </CommonGrid2>
  );
}
